







import Vue from 'vue';

import SubscribeForm from './SubscribeForm.vue';
import StatusMessage from './StatusMessage.vue';

export default Vue.extend({
	components: {
		SubscribeForm,
		StatusMessage
	}
})
